import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CameraCheckerService {
  checkCamera(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (navigator?.mediaDevices?.enumerateDevices) {
        navigator.mediaDevices
          .enumerateDevices()
          .then((devices) => {
            const hasCamera = devices.some(
              (device) => device.kind === 'videoinput'
            );
            observer.next(hasCamera);
          })
          .catch((error) => {
            console.error('Error al enumerar dispositivos: ' + error);
            observer.next(false);
          });
      } else {
        console.log('La API de medios no es compatible en este navegador.');
        observer.next(false);
      }
    });
  }
}
